<div portal-input-desconto>
  <div appearance="outline" FloatLabelType="never" (click)="$event.preventDefault(); alertRodape()">
    <span (click)="switchPrefix(); $event.preventDefault(); $event.stopPropagation()">{{ matPrefix }}</span>
    <input
    *ngIf="matPrefix === 'R$'; else percentage"
    matInput
    type="text"
    inputmode="decimal"
    [mask]="'separator.7'"
    [validation]="false"
    [dropSpecialCharacters]="true"
    [formControl]="descontoControl"
    (focusout)="applyDiscout($event)"
    (keyup.enter)="applyDiscout($event)"
    [decimalMarker]="decimalMarkers"
    thousandSeparator=""
    />
    <span
      (mousedown)="$event.preventDefault()"
      (click)="switchSignal(); $event.stopPropagation()"
    >{{signal}}</span>

  <ng-template #percentage>
    <input
      matInput
      type="text"
      inputmode="decimal"
      [mask]="'separator.7'"
      [validation]="false"
      [dropSpecialCharacters]="true"
      [decimalMarker]="decimalMarkers"
      thousandSeparator=""
      [formControl]="descontoControl"
      (focusout)="applyDiscout($event)"
      (keyup.enter)="applyDiscout($event)"
    />
  </ng-template>
  </div>
</div>
